export default __webpack_public_path__ + "static/media/BS02.6fa54094.jpg";